import { AllegatoDto } from "@api/client";
import { FileDocument } from "models/files";

export namespace FilesUtils {
	export const downloadFileBase64 = (file: string, fileName: string = new Date().toISOString()) => {
		let url = "data:image/png;base64," + file;
		let a = document.createElement("a");

		document.body.appendChild(a);

		a.setAttribute("style", "display: none");
		a.href = url;
		a.download = fileName;
		a.click();

		window.URL.revokeObjectURL(url);

		a.remove();
	};

	export const AllegatoDtoToFileDocument = (allegato?: AllegatoDto) => {
		if (!allegato) return undefined;

		return {
			name: allegato?.nomeFile,
			idTipoDocumento: allegato?.tipoDocumento || "",
			idTipoAllegato: allegato?.idAllegato || "",
		} as FileDocument;
	};
}
